<ion-tabs #tabs (ionTabsDidChange)="setSelectedTab()">
  <ng-container *ngIf="!router.url.includes('/touch/error')">
    <div
      class="become-a-customer-buttons"
      *ngIf="isGuestUser && (platformService.platformType === platformService.platformEnum.mobile)"
    >
      <ion-button
        class="usf-fill-green-button become-a-customer-touch-page-button"
        data-cy="become-a-customer-touch-page-button"
        (click)="onBecomeACustomerClick()"
      >
        <span>{{ 'i18n.common.becomeACustomer' | translate }}</span>
      </ion-button>
      <ion-button
        class="usf-outline-green-button guest-login-touch-page-button"
        data-cy="guest-login-touch-page-button"
        (click)="logout()"
      >
        <span>{{ 'i18n.common.logIn' | translate }}</span>
      </ion-button>
    </div>

    <ion-tab-bar
      #tabBar
      *ngIf="!!(orderService.restrictNavigationForCurrentOrder$ | async) === false"
      slot="bottom"
    >
      <!-- Home -->
      <ion-tab-button tab="home" appAddShrinkAnimationOnClick>
        <ion-icon
          [name]="selectedTab === 'home' ? 'home-sharp' : 'home-outline'"
        ></ion-icon>
        <ion-label translate>{{'i18n.navMobile.homeTab'}}</ion-label>
      </ion-tab-button>

      <!-- Lists -->
      <ion-tab-button
        tab="lists"
        *ngIf="!isGuestUser"
        appAddShrinkAnimationOnClick
      >
        <ion-badge *ngIf="listUpdatesExist$ | async"> ! </ion-badge>
        <ion-icon
          [name]="selectedTab === 'lists' ? 'reader' : 'reader-outline'"
        ></ion-icon>
        <ion-label translate>{{'i18n.navMobile.listsTab'}}</ion-label>
      </ion-tab-button>

      <!-- My Orders -->
      <ion-tab-button
        tab="my-orders-view"
        *ngIf="!isGuestUser"
        appAddShrinkAnimationOnClick
      >
        <ion-icon
          [src]="selectedTab === 'my-orders-view' ? '/assets/icon/menu-delivery-green-filled.svg' : '/assets/icon/menu-delivery-black.svg'"
        ></ion-icon>
        <ion-label translate>{{'i18n.navMobile.ordersTab'}}</ion-label>
      </ion-tab-button>

      <!-- Notifications -->
      <ion-tab-button
        tab="notifications"
        *ngIf="!isGuestUser"
        [routerLink]="['/touch/notifications']"
        appAddShrinkAnimationOnClick
      >
        <ion-badge *ngIf="unreadNotifications && unreadNotifications > 0">
          {{ unreadNotifications }}
        </ion-badge>
        <ion-icon
          [name]="selectedTab === 'notifications' ? 'notifications' : 'notifications-outline'"
        ></ion-icon>
        <ion-label translate>{{'i18n.navMobile.notificationsTab'}}</ion-label>
      </ion-tab-button>

      <!-- More -->
      <ion-tab-button
        data-cy="mobile-more-tab"
        tab="more"
        [routerLink]="['/touch/more']"
        appAddShrinkAnimationOnClick
      >
        <ion-icon name="menu"></ion-icon>
        <ion-label translate>{{'i18n.navMobile.menuTab'}}</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  </ng-container>
</ion-tabs>

<div *ngIf="showFab" class="usabilla-touch" (click)="feedbackButton()">
  <img
    class="usabilla-img"
    src="assets/images/feedback-button.png"
    alt="get feedback button"
  />
</div>
